import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MessageListener } from '../MessageListener';
import { config } from '../../config';
import { forceSignOut } from '../accesstoken';
import { getExpectedUserId } from '../sessionIdentity';

const managerOrigin = new URL(config.VITE_MANAGER_URL).origin;

export const IframePage = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [initialLng] = useState(i18n.language);
  const [now] = useState(() => Date.now());

  const params = new URLSearchParams(location.search);
  params.set('lng', initialLng);

  const outerExpectedUserId = getExpectedUserId();
  if (outerExpectedUserId) {
    params.set('expectedUserId', outerExpectedUserId);
  }
  const iframeUrl = `${config.VITE_MANAGER_URL}${location.pathname}?${params.toString()}`;

  const onMessage = useCallback((e: MessageEvent) => {
    if (e.data.event === 'navigated') {
      const sp = new URLSearchParams(e.data.search);
      sp.delete('lng');
      sp.delete('expectedUserId');
      const search = sp.toString();
      history.replaceState(history.state, '', e.data.pathname + (search ? `?${search}` : ''));
    } else if (e.data.event === 'session-invalid') {
      if (e.origin === managerOrigin) {
        forceSignOut('session-ended');
      }
    }
  }, []);

  useEffect(() => {
    const handler = (language: string) => {
      iframeRef.current?.contentWindow?.postMessage({ event: 'languageChanged', language }, { targetOrigin: '*' });
    };
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, [i18n]);

  return (
    <MessageListener onMessage={onMessage}>
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        key={history.state?.key ?? now}
        style={{
          width: '100%',
          height: '93.5vh', // not 100 to adapt to header navbar
          border: 'none',
        }}
        allow="clipboard-write"
      />
    </MessageListener>
  );
};
